import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { LLSelectField } from 'components/FormElements';
import MenuItem from 'material-ui/MenuItem';
import PropTypes from 'prop-types';

var ctaSortFunc = function ctaSortFunc(a, b) {
  var aStr = typeof a === 'string' ? a : a[0];
  var bStr = typeof b === 'string' ? b : b[0];

  if (aStr < bStr) {
    return -1;
  }

  if (aStr > bStr) {
    return 1;
  }

  return 0;
};

var FacebookCTASelector = /*#__PURE__*/function (_Component) {
  _inherits(FacebookCTASelector, _Component);

  var _super = _createSuper(FacebookCTASelector);

  function FacebookCTASelector() {
    var _this;

    _classCallCheck(this, FacebookCTASelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "websiteClickTypes", ['LEARN_MORE', 'CONTACT_US', 'LISTEN_NOW', 'GET_SHOWTIMES', 'DOWNLOAD', 'DONATE_NOW', 'APPLY_NOW', 'NO_BUTTON', 'WATCH_MORE', ['BOOK_TRAVEL', 'Book Now'], 'GET_OFFER', 'GET_QUOTE', 'REQUEST_TIME', 'SEE_MENU', 'SHOP_NOW', 'SIGN_UP', 'SUBSCRIBE'].sort(ctaSortFunc));

    _defineProperty(_assertThisInitialized(_this), "leadGenTypes", ['GET_QUOTE', 'LEARN_MORE', 'SIGN_UP', 'APPLY_NOW', 'DOWNLOAD', 'SUBSCRIBE', 'GET_OFFER', ['BOOK_TRAVEL', 'Book Now']].sort(ctaSortFunc));

    _defineProperty(_assertThisInitialized(_this), "postEngagementTypes", ['NO_BUTTON', 'LEARN_MORE', 'SEND_MESSAGE', 'SHOP_NOW'].sort(ctaSortFunc));

    _defineProperty(_assertThisInitialized(_this), "optionMapFunc", function (option) {
      return {
        type: option instanceof Array ? option[0] : option,
        label: option instanceof Array ? option[1] : _this.titleCase(option.split('_').join(' '))
      };
    });

    _defineProperty(_assertThisInitialized(_this), "titleCase", function (str) {
      str = str.toLowerCase().split(' ');

      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }

      return str.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "optionsForAdType", function (adType) {
      if (!adType) {
        return _this.websiteClickTypes.map(_this.optionMapFunc);
      }

      var array = [];

      switch (adType) {
        case 'pageLike':
          array = _this.postEngagementTypes;
          break;

        case 'leadGeneration':
          array = _this.leadGenTypes;
          break;

        case 'clicksToWebsite':
          array = _this.websiteClickTypes;
          break;

        default:
          break;
      }

      return array.map(_this.optionMapFunc);
    });

    return _this;
  }

  _createClass(FacebookCTASelector, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (!this.props.value) {
        this.props.onChange('NO_BUTTON');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // If an adType is specified in the props we only want to give back options that are appropriate for that adType
      var options = this.optionsForAdType(this.props.adType);
      return /*#__PURE__*/React.createElement(LLSelectField, {
        fullWidth: true,
        value: this.props.value,
        onChange: function onChange(e, i, val) {
          return _this2.props.onChange(val);
        },
        label: "Call To Action"
      }, options.map(function (t, i) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: t.type,
          primaryText: t.label,
          key: i
        });
      }));
    }
  }]);

  return FacebookCTASelector;
}(Component);

_defineProperty(FacebookCTASelector, "propTypes", {
  onChange: PropTypes.func.isRequired,
  adType: PropTypes.string,
  value: PropTypes.string
});

export { FacebookCTASelector as default };